// extracted by mini-css-extract-plugin
export default {"title":"App_title__X0AwC","row":"App_row__3qChH"};